import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Papa from 'papaparse';
import getModelApiConfig from "../util/apiConfig";
import { azureFetch } from "../../../api/azureFetch";

const API_BASE_URL = process.env.REACT_APP_HOST_URL;

function useGetModelTrainResults(id) {

    const { baseHeaders, baseUrl } = getModelApiConfig();


    const [csvHeaders, setCsvHeaders] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [modelResults, setModelResults] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        azureFetch(`getCAMJobDetails/${id}`)
            .then((res) => {
                const csv_file_name = res.csv_file_name
                fetch(API_BASE_URL + "/DownloadTrainingDataCSV", {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "text/csv",
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify({ "file_name": csv_file_name }),
                }).then((response) => {
                if (response.ok) {
                    return response.blob();
                } else {
                    throw new Error('Network response was not ok');
                }
                }).then((blob) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const text = reader.result;
                    Papa.parse(text, {
                        header: true,
                        complete: (results) => {
                            setCsvHeaders(results.meta.fields);
                            setCsvData(results?.data.map((row) => Object.values(row)));
                        },
                    });
                };
                reader.readAsText(blob);
                setModelResults(res);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching model results:", error);
                toast.error("Error fetching model results. Please try again later.");
                setLoading(false);
            });
            })
    }, [id]);


    return { csvHeaders, csvData, modelResults, loading };


}


export default useGetModelTrainResults;